import type {
  IRenderContext,
  Visual,
  INode,
  Constructor,
  Rect,
} from '@ardoq/yfiles';
import { LeafNodeVisual } from './leafNode/LeafNodeVisual';
import { ModernizedNodeStyleBase } from './ModernizedNodeStyleBase';
import {
  buildLeafProps,
  createNodeExportSupportLookup,
  getColor,
} from './leafNode/util';

export class ArdoqImageStyle extends ModernizedNodeStyleBase {
  private readonly nodeExportSupportLookup = createNodeExportSupportLookup(
    (context, node) => this.getLayout(context, node)
  );

  constructor(private imageUrl: string) {
    super();
  }

  protected override lookup(node: INode, type: Constructor): unknown {
    return this.nodeExportSupportLookup(node, type) ?? super.lookup(node, type);
  }

  protected getLayout(context: IRenderContext, node: INode): Rect {
    const props = buildLeafProps(node, context, { imageHref: this.imageUrl });
    return LeafNodeVisual.getLayout(props);
  }

  protected override createVisual(
    context: IRenderContext,
    node: INode
  ): Visual | null {
    const props = buildLeafProps(node, context, {
      imageHref: this.imageUrl,
    });
    const color = getColor(node);
    return new LeafNodeVisual({
      ...props,
      color,
    });
  }
}
